<template>
  <div id="wizard">
    <v-stepper v-model="currentStep">
      <div class="wizard-header" :class="{ 'header-underline': currentStep === 6 || isMobile }">
        <v-container>
          <template v-if="!isMobile">
            <v-stepper-header>
              <v-stepper-step
                v-for="(item, index) in wizardItems"
                :key="index + 1"
                :edit-icon="'mdi-circle'"
                :complete-icon="'mdi-check'"
                :complete="currentStep > index + 1"
                :step="index + 1"
                @click="stepClick(index + 1)"
                :class="[isStepDisabled(index) ? 'stepper-disabled' : '']"
              >
                {{ index }}. {{ item.title }}
              </v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </template>
          <template v-else>
            <v-row
              no-gutters
              style="gap: 16px"
              class="px-4 py-6 ma-0"
              v-if="wizardItems.length > 0 && currentStep > 0"
            >
              <v-col cols="12" md="12">
                <v-row class="ma-0" style="gap: 8px">
                  <v-col
                    v-for="index in wizardItems.length - 1"
                    :key="index"
                    style="padding: 0 !important"
                  >
                    <v-progress-linear
                      style="height: 6px; border-radius: 4px"
                      :key="index"
                      :value="getStep(index)"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="wizard-header-section">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div class="wizard-header-section-header">
                        <span class="wizard-header-section-header-krok">
                          Krok {{ currentStep - 1 }}/{{ wizardItems.length - 1 }}
                        </span>
                        <span class="wizard-header-section-header-title">
                          {{ wizardItems[currentStep - 1].formTitle }}
                        </span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-divider class="mt-2"></v-divider>
                      <v-list dense>
                        <v-list-item-group :value="currentStep - 1" color="primary">
                          <v-list-item
                            v-for="(item, index) in wizardItems"
                            :key="index + 1"
                            @click="stepClick(index + 1)"
                            :class="[isStepDisabled(index) ? 'stepper-disabled' : '']"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                :class="
                                  index + 1 < currentStep
                                    ? 'wizard-header-section-list-complete'
                                    : index + 1 == currentStep
                                    ? 'wizard-header-section-list-active'
                                    : ''
                                "
                              >
                                {{ index }}. {{ item.title }}
                                <v-icon
                                  v-if="index + 1 < currentStep"
                                  class="wizard-header-section-list-icon-complete"
                                  >{{ 'mdi-check' }}</v-icon
                                >
                                <v-icon
                                  v-else-if="index + 1 == currentStep"
                                  class="wizard-header-section-list-icon-active"
                                  >{{ 'mdi-circle' }}</v-icon
                                >
                                <v-icon v-else style="font-size: 0px"></v-icon>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </div>
      <v-stepper-items ref="wizardStepperItems">
        <!-- <template v-if="sumarOnly">
                  <v-stepper-content :step="6">6</v-stepper-content>
                </template> -->
        <v-stepper-content
          class="pa-0"
          v-for="(item, index) in wizardItems"
          :key="index"
          :step="item.step"
        >
          <template v-if="item.isAlive">
            <component
              v-show="!isStepDisabled(index)"
              :ref="item.step"
              :is="item.formName"
              :mainTabStep="currentStep"
              :currentControl="currentForm"
              :controlName="item.formName"
              :title="item.formTitle"
              @validationChanged="handleValidationChanged"
              @setCustomButton="handleSetCustomButton"
              @setCustomButtonSecondary="handleSetCustomButtonSecondary"
              @dirtyChanged="val => dirtyChanged(item, val)"
              @formControlsLoaded="formControlsLoaded(item, index)"
              @somethingIsLoadingChanged="val => somethingIsLoadingChanged(item, val)"
              @loadingOverlayChanged="handleWizardLoadingOverlayChanged"
              @predmetSelected="onPredmetSelect"
              @setNotAliveComponent="setNotAliveComponent"
              @modelyVerzieChanged="handleModelyVerzieChanged"
            >
            </component>
          </template>
        </v-stepper-content>
      </v-stepper-items>
      <div class="wizard-footer" v-if="showFooter" ref="wizardFooter">
        <v-container>
          <v-row align="center">
            <v-col cols="12" md="5" :style="debug ? { display: 'flex' } : ''">
              <span v-if="wizardValidation.message.text || wizardValidation.showProgress">
                <span
                  v-if="wizardValidation.message.text"
                  :class="{
                    negative500: wizardValidation.message.isError,
                    bold: wizardValidation.message.isError,
                    notError: !wizardValidation.message.isError,
                  }"
                  v-html="wizardValidation.message.text"
                >
                </span>
                <v-progress-circular
                  v-if="wizardValidation.showProgress"
                  class="ml-20px"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </span>
              <ul v-if="debug">
                <li>OBC: {{ pripad.cislo }}</li>
                <li>NEW_ID: {{ pripad.newId }}</li>
              </ul>
            </v-col>
            <v-col md="auto" class="ml-md-auto" cols="12">
              <v-row no-gutters align="center" class="wizard-footer-buttons">
                <v-col v-if="customButtonSecondary.visible" md="auto" cols="12">
                  <v-btn large class="btn-secondary" @click="customButtonSecondary.onClick()">
                    <span class="break-word">
                      {{ customButtonSecondary.text }}
                    </span>
                  </v-btn>
                </v-col>
                <v-col
                  v-if="!customButtonSecondary.visible"
                  v-show="currentStep > 1 && !isWizardSumar && !isStepDisabled(currentStep - 2)"
                  md="auto"
                >
                  <v-btn large class="btn-secondary" @click="stepClick(currentStep - 1)">
                    <span> Späť </span>
                  </v-btn>
                </v-col>
                <v-col v-if="customButton.visible" md="auto" cols="12">
                  <v-btn
                    large
                    :disabled="!customButton.enabled"
                    @click="customButton.onClick"
                    class="btn-primary"
                  >
                    <span class="break-word">
                      {{ customButton.text }}
                    </span>
                  </v-btn>
                </v-col>
                <v-col
                  v-if="!customButton.visible"
                  v-show="!isWizardSumar && currentStep < wizardItems.length"
                  md="auto"
                >
                  <v-btn
                    large
                    :disabled="!wizardValidation.valid"
                    class="btn-primary"
                    @click="stepClick(currentStep + 1)"
                  >
                    Pokračovať
                    <v-icon right dark> arrow_right_alt </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- <v-btn
            large
            class="btn-secondary"
            v-if="customButtonSecondary.visible"
            @click="customButtonSecondary.onClick()"
          >
            {{ customButtonSecondary.text }}
          </v-btn>
          <v-btn
            v-show="currentStep > 1 && !isWizardSumar && !isStepDisabled(currentStep - 2)"
            large
            class="btn-secondary"
            v-if="!customButtonSecondary.visible"
            @click="stepClick(currentStep - 1)"
          >
            Späť
          </v-btn>
          <v-btn
            large
            v-if="customButton.visible"
            :disabled="!customButton.enabled"
            @click="customButton.onClick"
            class="btn-primary"
          >
            {{ customButton.text }}
          </v-btn>
          <v-btn
            v-show="!isWizardSumar && currentStep < wizardItems.length"
            v-if="!customButton.visible"
            large
            :disabled="!wizardValidation.valid"
            class="btn-primary"
            @click="stepClick(currentStep + 1)"
          >
            Pokračovať
            <v-icon right dark> arrow_right_alt </v-icon>
          </v-btn> -->
        </v-container>
      </div>
    </v-stepper>

    <!-- iny operator modifikuje -->
    <v-container
      v-if="modifikujeOperator && modifikujeOperator !== this.user.login"
      class="mt-100px"
    >
      <v-card class="card">
        <h2>Upozornenie</h2>
        <br />
        <span class="f18" v-if="jeDealer">
          Obchodný prípad
          <span class="bold primary500">{{ cisloObchPripadu }}</span>
          je aktuálne modifikovaný operátorom
          <span class="bold">{{ modifikujeOperator }}</span
          >.
        </span>
        <span class="f18" v-else>
          Obchodný prípad
          <span class="bold primary500">{{ cisloObchPripadu }}</span>
          je aktuálne modifikovaný iným používateľom.
        </span>
      </v-card>
    </v-container>
    <v-container v-if="nemaPravoEditovat" class="mt-100px">
      <v-card class="card">
        <h2>Upozornenie</h2>
        <br />
        <span class="f18">
          Nemáte právo editovať obchodný prípad
          <span class="bold primary500">{{ cisloObchPripadu }}</span
          >.
        </span>
      </v-card>
    </v-container>
    <v-container v-if="!maStredisko" class="mt-100px">
      <v-card class="card">
        <h2>Upozornenie</h2>
        <br />
        <span class="f18">
          Nie je možné vytvoriť nový obchodný prípad. Nemáte nastavené stredisko.
        </span>
      </v-card>
    </v-container>
    <v-container v-if="rozpracovanySumar" class="mt-100px">
      <v-card class="card">
        <h2>Upozornenie</h2>
        <br />
        <span class="f18">
          Na rozpracovanom prípade nie je možné zobraziť sumár. Prípad najskôr prosím dokončite.
        </span>
      </v-card>
    </v-container>

    <!-- ############## DIALOG ulozenie ############## -->
    <v-dialog v-model="saveDialogWithEmail" max-width="500">
      <v-card class="dialog-card">
        <v-card-title class="d-flex justify-space-between dialog-title-close">
          <span> Uložiť ponuku a odoslať na e-mail </span>
          <v-btn icon @click="closeSaveDialogWithEmail()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="gs100">
          <v-form :ref="'saveCloseDialogForm'" autocomplete="off">
            <span>
              Ponuku si môžete odoslať na vašu e-mailovú adresu a neskôr sa k nej vrátiť.
            </span>
            <br />
            <a v-if="urlMemorandum.length > 0" :href="urlMemorandum"
              >Informácia o spracúvaní osobných údajov.</a
            >
            <text-box
              class="mt-10px"
              label="Zadajte e-mailovú adresu"
              v-model="saveEmail"
              :isEnabled="true"
              :required="true"
              :rules="[
                v => emailRegex.test(v) || !saveEmail || !v || 'Nesprávny formát e-mailovej adresy',
              ]"
              hideRequired
            >
            </text-box>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-primary" @click="checkEmail()"> Odoslať </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay color="#000" opacity="0.40" :value="loadingRefi.loading" :z-index="5">
      <v-card width="500" class="text-center mt-n100px card">
        <v-progress-circular class="mb-20px" indeterminate color="primary" :size="25" :width="2" />
        <text-group
          invert
          large
          :utext="loadingRefi.text"
          :btext="'Upozornenie'"
          :gap="20"
        ></text-group>
      </v-card>
    </v-overlay>
    <v-overlay
      color="#000"
      opacity="0.40"
      :value="
        somethingIsLoading ||
        (!editInitialized && !loadingRefi.loading) ||
        sumarLoading ||
        sendMail ||
        wizardLoadingOverlay.loading
      "
      :z-index="6"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        :size="isMobile ? 30 : 60"
        :width="5"
        class="mr-10px"
      />
      <template v-if="!sendMail"> Prebieha načítanie dát, prosím počkajte ... </template>
      <template v-else> Odosielanie emailu, prosím počkajte ... </template>
    </v-overlay>
  </div>
</template>

<script>
import PripadyWizardPoistenie from '../components/pripady_wizard/PripadyWizardPoistenie';
import PripadyWizardNajomca from '../components/pripady_wizard/PripadyWizardNajomca.vue';
import PripadyWizardUvod from '../components/pripady_wizard/PripadyWizardUvod.vue';
import PripadyWizardPredmet from '../components/pripady_wizard/PripadyWizardPredmet.vue';
import PripadyWizardProdukt from '../components/pripady_wizard/PripadyWizardProdukt.vue';
import PripadyWizardSumar from '../components/pripady_wizard/PripadyWizardSumar.vue';
import PripadyWizardKalkulacia from '../components/pripady_wizard/PripadyWizardKalkulacia.vue';
import TextGroup from '../components/basic/TextGroup.vue';
import TextBox from '../components/basic/TextBox.vue';
import protectedAxios from '../auth/axios.js';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { eventBus } from '../main.js';
import { store } from '../store.js';
import { cacheMixin } from '../mixins/cacheMixin';
import { globalMixin } from '../mixins/globalMixin.js';
const { isSumarRouteNormalization } = require('../utils/sumarFlow');

export default {
  mixins: [cacheMixin, globalMixin],
  components: {
    PripadyWizardPoistenie,
    PripadyWizardNajomca,
    PripadyWizardPredmet,
    PripadyWizardProdukt,
    PripadyWizardSumar,
    PripadyWizardKalkulacia,
    PripadyWizardUvod,
    TextGroup,
    TextBox,
  },
  computed: {
    ...mapState(['pripad', 'wizardFormControls']),
    ...mapGetters('auth', ['user']),
    ...mapGetters([
      'vytvaranieZakaznikaPrebieha',
      'jeDealer',
      'jePrihlaseny',
      'externalUrl',
      'externalUrlData',
      'externalUrlFrom',
      'isMobile',
    ]),
    currentForm() {
      if (this.currentStep === 0) return null;
      return this.wizardItems[this.currentStep - 1].formName;
    },
    somethingIsLoading() {
      return this.wizardItems
        .filter(c => c.formName !== 'PripadyWizardSumar' && c.isAlive)
        .map(c => c.somethingIsLoading)
        .reduce((a, v) => a || v, false);
    },
  },
  watch: {
    externalUrl(val) {
      if (val != null) {
        this.redirectToExternalUrl(val);
      }
    },
    // somethingIsLoading(val){
    //   console.log('loading',val,this.editInitialized,this.wizardItems[this.currentStep-1]?.somethingIsLoading);
    //   // if(this.wizardItems.length > 0){
    //   //   if(val == false && !this.wizardItems[this.currentStep-1].somethingIsLoading && this.isStepDisabled(this.currentStep -1)){
    //   //     this.setStep(this.currentStep+1);
    //   //   }
    //   // }
    // },
    // editInitialized(val){
    //   console.log('editInitialized',val,this.somethingIsLoading,this.currentStep);
    // },
    // currentStep(val){
    //   console.log('currentStep',val,this.somethingIsLoading,this.editInitialized);
    // }
    somethingIsLoading(val) {
      if (!val && this.isMobile) {
        this.$nextTick(() => {
          if (this.$refs.wizardFooter) {
            this.updateStepperPadding();
            this.observer = new ResizeObserver(this.updateStepperPadding);
            this.observer.observe(this.$refs.wizardFooter);
          }
        });
      }
    },
    currentStep(val) {
      if (val == 6 && this.isMobile) {
        this.$nextTick(() => {
          if (this.$refs.wizardFooter) {
            this.updateStepperPadding();
            this.observer = new ResizeObserver(this.updateStepperPadding);
            this.observer.observe(this.$refs.wizardFooter);
          }
        });
      }
    },
  },
  data() {
    return {
      debug: window._env_config.DEBUG,
      saveDialog: {
        header: '',
        text: '',
        persistent: this.saveInProgress,
        closeIcon: {
          value: false,
          func: null,
        },
        secondaryBtn: {
          text: '',
          func: null,
          disabled: false,
          loading: false,
        },
        primaryBtn: {
          text: '',
          func: null,
          disabled: false,
          loading: false,
        },
        callNext: null,
        email: null,
        open: false,
        inProgress: false,
      },
      saveInProgress: false,
      saveDialogWithEmail: false,
      sumarOnly: false,
      editInitialized: false,
      scrollTimeout: null,
      currentStep: 0,
      redirectHandler: null,
      wizardValidation: {
        valid: true,
        message: {
          text: '',
          isError: false,
        },
        showProgress: false,
        blocked: false,
      },
      showFooter: false,
      modifikujeOperator: null,
      modifikovalOperator: null,
      nemaPravoEditovat: null,
      maStredisko: true,
      rozpracovanySumar: false,
      customButton: {
        visible: false,
        enabled: false,
        text: '',
        onClick: () => {},
      },
      customButtonSecondary: {
        visible: false,
        text: '',
        onClick: () => {},
      },
      loadingRefi: {
        loading: false,
        text: '',
      },
      wizardLoadingOverlay: {
        loading: false,
      },
      wizardItems: [],
      allWizardItems: [
        {
          title: 'Nájomca',
          formName: 'PripadyWizardNajomca',
          formTitle: 'Nájomca',
          dirty: false,
          isAlive: false,
          controlsLoaded: false,
          somethingIsLoading: true,
          step: 1,
          isDealer: true,
        },
        {
          title: 'Úvod',
          formName: 'PripadyWizardUvod',
          formTitle: 'Úvod',
          dirty: false,
          isAlive: false,
          controlsLoaded: false,
          somethingIsLoading: true,
          step: 1,
          isDealer: false,
        },
        {
          title: 'Predmet',
          formName: 'PripadyWizardPredmet',
          formTitle: 'Chcem financovať',
          dirty: false,
          isAlive: false,
          controlsLoaded: false,
          somethingIsLoading: false,
          step: 2,
        },
        {
          title: 'Produkt',
          formName: 'PripadyWizardProdukt',
          formTitle: 'Naše produkty',
          dirty: false,
          isAlive: false,
          controlsLoaded: false,
          somethingIsLoading: false,
          step: 3,
        },
        {
          title: 'Poistenie',
          formName: 'PripadyWizardPoistenie',
          formTitle: 'Poistenie',
          dirty: false,
          isAlive: false,
          controlsLoaded: false,
          somethingIsLoading: false,
          step: 4,
        },
        {
          title: 'Kalkulácia',
          formName: 'PripadyWizardKalkulacia',
          formTitle: 'Kalkulácia',
          dirty: false,
          isAlive: false,
          controlsLoaded: false,
          somethingIsLoading: false,
          step: 5,
        },
        {
          title: 'Sumár',
          formName: 'PripadyWizardSumar',
          formTitle: 'Sumár',
          dirty: false,
          isAlive: false,
          controlsLoaded: false,
          somethingIsLoading: false,
          step: 6,
        },
      ],
      emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      saveEmail: '',
      checkEmailZakaznika: false,
      existujeZakaznik: false,
      sumarLoading: false,
      sendMail: false,
      isWizardSumar: true,
      urlMemorandum: '',
      jeNovy: true,
      externalRedirect: false,
      neexistujePripad: false,
      cisloObchPripadu: '',
      newId: '',
      isActiveStepClick: false,
    };
  },
  methods: {
    ...mapMutations(['setPripad', 'openDialog', 'closeDialog']),
    getStep(index) {
      if (index < this.currentStep) return 100;
      if (this.currentStep === 6) return 100;
      return 0;
    },
    async stepClick(step) {
      if (this.pripad?.newId == null) return;
      if (this.isStepDisabled(step - 1)) return;
      if (this.currentStep === step) return;
      if (this.somethingIsLoading) return;
      if (this.wizardValidation.blocked) return;
      if (this.isActiveStepClick) return;
      if (this.currentStep == 6){
        let indexPredmetu = this.$refs[this.currentStep][0]?.showPredmet ?? -1;
        if(indexPredmetu > -1){
          this.$router.push(`/obchodny-pripad/${this.pripad.newId}?cislo_predmetu=${indexPredmetu + 1}&step=${step}`);
        }else{
          this.$router.push(`/obchodny-pripad/${this.pripad.newId}?step=${step}`);
        }
      }
      if (!this.wizardItems[this.currentStep - 1].controlsLoaded) return;
      this.isActiveStepClick = true;

      if (step < this.currentStep) {
        //ide dozadu
        this.setStep(step);
        this.$vuetify.goTo(0, { duration: 0, easing: 'linear' });
        this.clearCustomButton();
        this.isActiveStepClick = false;
        return;
      }

      //ak je aktualny form dirty, vsetky vyssie odmazem
      if (this.wizardItems[this.currentStep - 1].dirty) {
        this.wizardItems.forEach((form, i) => {
          if (i + 1 > this.currentStep) form.isAlive = false;
        });
      }

      //existuje form na ktory skacem?
      if (
        step - this.currentStep > 1 &&
        (!this.wizardItems[step - 1].isAlive || this.pripad.jeRozpracovany)
      ) {
        this.clearCustomButton();
        this.isActiveStepClick = false;
        return;
      }
      const formValid = await this.$refs[this.currentStep][0].validateForm();
      let canContinue = this.wizardValidation.valid && formValid;

      if (!formValid) {
        this.clearCustomButton();
        eventBus.$emit('snack-error', 'Pre pokračovanie prosím vyplňte všetky povinné polia!');
        this.isActiveStepClick = false;
      }

      if (!canContinue) {
        this.clearCustomButton();
        this.isActiveStepClick = false;
        return;
      }

      if (this.wizardItems[step - 1].formName === 'PripadyWizardSumar') {
        let changedCache = await this.checkCacheChanged();
        if (changedCache) {
          this.$refs[this.currentStep][0].akontaciaTenorValid();
          this.isActiveStepClick = false;
          return;
        }
      }
      //beforeStep() musi vracat Promise !!!
      this.$refs[this.currentStep][0].beforeStep().then(res => {
        if (canContinue && res) {
          this.clearCustomButton();
          this.$vuetify.goTo(0, { duration: 0, easing: 'linear' });
          if (this.wizardItems[step - 1].formName === 'PripadyWizardSumar') {
            window.onbeforeunload = null;
            this.$router.push(`/obchodny-pripad/${this.pripad.newId}/sumar`);
          } else {
            this.setStep(step);
            this.isActiveStepClick = false;
          }
        } else {
          this.isActiveStepClick = false;
        }
      })
        

    },
    handleValidationChanged(eventArg) {
      this.wizardValidation.showProgress = eventArg.showProgress;
      this.wizardValidation.valid = eventArg.valid;
      this.wizardValidation.message = eventArg.message;
      this.wizardValidation.blocked = eventArg.blocked;
    },
    handleSetCustomButton(eventArg) {
      this.customButton.visible = eventArg.visible;
      this.customButton.enabled = eventArg.enabled;
      this.customButton.text = eventArg.text;
      this.customButton.onClick = 
        eventArg.onClick != null ? eventArg.onClick : this.openSaveDialog;
    },
    handleSetCustomButtonSecondary(eventArg) {
      this.customButtonSecondary.visible = eventArg.visible;
      this.customButtonSecondary.text = eventArg.text;
      this.customButtonSecondary.onClick =
        eventArg.onClick != null ? eventArg.onClick : this.openSaveDialog;
    },
    clearCustomButton() {
      this.customButton.visible = false;
      this.customButton.enabled = false;
      this.customButton.text = '';
      this.customButton.onClick = () => {};
    },
    dirtyChanged(item, val) {
      item.dirty = val;
    },
    formControlsLoaded(item, index) {
      item.controlsLoaded = true;
      this.loadNextForm(index);
    },
    somethingIsLoadingChanged(item, val) {
      item.somethingIsLoading = val;
    },
    handleWizardLoadingOverlayChanged({ loading }) {
      this.wizardLoadingOverlay.loading = loading;
    },
    handleModelyVerzieChanged(cisloPredmetu) {
      const predmetStep = this.$refs[2]?.[0];
      predmetStep?.refreshModelyVerzie(cisloPredmetu);
    },
    async SetPripadAndContinue(cisloPredmetu) {
      let cislo_predmetu = cisloPredmetu ?? 1;
      if (this.$route.query.duplikovat_predmet) {
        cislo_predmetu = parseInt(this.$route.query.duplikovat_predmet);
      }

      const jeRozpracovanyDB = await protectedAxios
        .get(`/pripady/${this.newId}/je-rozpracovany`)
        .then(res => !!res.data);

      if (this.$route.name === 'pripadSumar' || this.$route.name === 'pripadSumarNajomca' || this.$route.name === 'pripadSumarDodatInfo') {
        this.isWizardSumar = true;
        if (jeRozpracovanyDB) {
          //zle je, na rozpracovanom pripade sa nesmie zobrazit sumar
          this.rozpracovanySumar = true;
        } else {
          window.onbeforeunload = null;
          this.setPripad({
            jeRozpracovany: jeRozpracovanyDB,
            cislo: this.cisloObchPripadu,
            cisloPredmetu: cislo_predmetu,
            canOpenPredmet: true,
            idZastupcu: 1,
            predmetZamknuty: false,
            newId: this.newId,
            jeOlfs: false,
          });

          this.editInitialized = true;
          this.sumarOnly = true;
          this.setStep(6);
        }
      } else {
        this.isWizardSumar = false;
        
        protectedAxios
          .get(`/pripady/${this.newId}/predmety/${cislo_predmetu}/je-zamknuty`)
          .then(async res => {
            this.setPripad({
              jeRozpracovany: jeRozpracovanyDB,
              cislo: this.cisloObchPripadu,
              cisloPredmetu: cislo_predmetu,
              canOpenPredmet: true,
              idZastupcu: 1,
              predmetZamknuty: res.data === 1,
              newId: this.newId,
              jeOlfs: false,
            });
            if (await this.checkCacheChanged()){
              if (this.$route.query.cislo_predmetu) this.wizardItems[2].dirty = true;
              if (this.$route.query.duplikovat_predmet) this.wizardItems[2].dirty = true;
              if (this.$route.query.step) this.wizardItems[parseInt(this.$route.query.step)].dirty = true ;
              if (this.$route.query.redirect) this.wizardItems[parseInt(this.$route.query.redirect)].dirty = true;
            }
            this.setStep(1);
          })
          .catch(e => console.error('Pri overení predmetu nastala chyba.', e));
      }
    },
    // confirmRedirect(saveBefore) {
    //   if (this.saveDialog.inProgress) return;
    //   this.saveDialog.inProgress = true;

    //   this.ulozPripad(saveBefore)
    //     .then(_ => {
    //       this.wizardItems.forEach((form, _) => {
    //         form.isAlive = false;
    //         form.dirty = false;
    //         form.controlsLoaded = false;
    //       });
    //       this.currentStep = 0;
    //       this.saveDialog.open = false;
    //       this.saveDialog.callNext(true);
    //     })
    //     .catch(e => {
    //       console.error(e);
    //       this.saveDialog.inProgress = false;
    //       this.saveDialog.open = false;
    //       eventBus.$emit('snack-error', 'Pri ukladaní nastala chyba.');
    //     });
    // },
    async openSaveDialog() {
      if (this.jePrihlaseny) {
        this.sendMail = true;
        return await protectedAxios
          .post(`/tlac/${this.pripad.newId}/generate-email?jePrihlaseny=${this.jePrihlaseny}`, {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(res => {
            this.sendMail = false;
            if (res.data.error > 0) {
              eventBus.$emit('snack-error', res.data.message);
            } else {
              const sentEmail = res.data.email;
              this.saveDialog.header = 'Uložiť ponuku a odoslať na e-mail';
              this.saveDialog.closeIcon = {
                value: true,
                func: this.resetAndCloseDialog,
              };
                if (this.jeDealer) {
                    this.saveDialog.text = `<span class="gs100">
                     Ponuka bola odoslaná na email klienta ${sentEmail}.
                     </span>`;
                            } else {
                                this.saveDialog.text = `<span class="gs100">
                     Ponuka bola úspešne odoslaná na váš e-mail ${sentEmail}. K ponuke sa viete vrátiť a upravovať ju až
                     do dátumu platnosti, ktorý nájdete uvedený v prílohe e-mailu.
                   </span>
                   <br />
                   <br />
                   <span class="gs100">
                     Súčasne sme ponuku uložili medzi <span style="font-weight: bold">Rozpracované financovanie</span> vo vašej Klientskej zóne.
                   </span>`;
                this.saveDialog.primaryBtn = {
                  text: 'Zobraziť Rozpracované financovanie',
                  func: async () => await this.sumarRedirectToClientZone(),
                };
              }

              this.openDialog(this.saveDialog);
            }
          })
          .catch(() => {
            this.sendMail = false;
          });
      } else {
        await protectedAxios.get(`/dokumenty/getMemorandumUrl`).then(res => {
          if (res.data.length > 0) this.urlMemorandum = res.data;
          this.saveDialogWithEmail = true;
        });
      }
    },
    async checkEmail() {
      let isValid = this.$refs.saveCloseDialogForm.validate();
      if (isValid) {
        this.sendMail = true;
        return await protectedAxios
          .post(
            `/pripady/${this.pripad.newId}/save-email`,
            {
              email: this.saveEmail,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(async res => {
            this.saveDialogWithEmail = false;
            let evidencedAndActived = res.data.length > 0;
            return await protectedAxios
              .post(`/tlac/${this.pripad.newId}/generate-email`, {
                headers: {
                  'Content-Type': 'application/json',
                },
              })
              .then(secondRes => {
                const sentEmail = secondRes.data.email || this.saveEmail;
                this.saveEmail = null;
                if (secondRes.data.error > 0) {
                  eventBus.$emit('snack-error', secondRes.data.message);
                } else {
                  this.saveDialog.header = 'Uložiť ponuku a odoslať na e-mail';
                  this.saveDialog.closeIcon = {
                    value: true,
                    func: this.resetAndCloseDialog,
                  };
                  if (evidencedAndActived) {
                      this.saveDialog.text = `<span class="white100">Zadaný e-mail je registrovaný v Klientskej zóne</span>
                        <br />
                        <br />
                        <span class="gs100">
                        Ponuka bola úspešne odoslaná na váš e-mail ${sentEmail}. K ponuke sa viete vrátiť a upravovať
                        ju až do dátumu platnosti, ktorý nájdete uvedený v prílohe e-mailu.
                        </span>
                        <br />
                        <br />
                        <span class="gs100">
                        Po prihlásení bude ponuka automaticky uložená medzi <span style="font-weight: bold">Rozpracované ponuky financovania</span> vo vašej Klientskej zóne.
                        </span>`;
                    this.saveDialog.primaryBtn = {
                      text: 'Prihlásiť sa ',
                      func: this.sumarRedirectToLogin,
                    };
                  } else {
                      this.saveDialog.text = `<span class="gs100">
                          Ponuka bola úspešne odoslaná na váš e-mail ${sentEmail}. K ponuke sa viete vrátiť a upravovať
                          ju až do dátumu platnosti, ktorý nájdete uvedený v prílohe e-mailu.
                        </span>`;
                  }
                  this.openDialog(this.saveDialog);
                }
              });
          })
          .finally(() => {
            this.sendMail = false;
            this.saveDialogWithEmail = false;
          });
      }
    },

    ulozPripad(saveBefore) {
      return protectedAxios
        .post(
          `pripady/save`,
          {
            newId: this.pripad.newId,
            cisloPredmetu: this.pripad.cisloPredmetu,
            idZastupcu: this.pripad.idZastupcu,
            jeRozpracovany: true,
            ulozit: saveBefore ? 1 : 0,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(_ => this.resetCacheWithPripad());
    },
    setStep(val) {
      if (this.wizardItems.length > 0) {
        if (!this.wizardItems[val - 1].somethingIsLoading && this.isStepDisabled(val - 1)) {
          val += 1;
        }
      }
      this.wizardItems[val - 1].isAlive = true;

      setTimeout(() => {
        this.currentStep = val;
        localStorage.setItem('curr_new_obc_step', val);
      }, 100);
    },
    loadPripad(newId) {
      this.newId = newId;
      this.wizardItems = this.allWizardItems.filter(
        item => item.step > 1 || item.isDealer == this.jeDealer
      );
      this.showFooter = true;
      let cisloPredmetu = parseInt(this.$route.query.cislo_predmetu ?? 1);

      protectedAxios
        .get('/controls/hascache')
        .then(res => {
          const newIdCache = res.data;
          if (this.newId && newIdCache && newIdCache.toLowerCase() !== this.newId.toLowerCase())
            return this.resetCache().then(_ => this.newId);

          if (newIdCache) return newIdCache;

          if (this.$route.name === 'pripadSumar' || this.$route.name === 'pripadSumarNajomca' || this.$route.name === 'pripadSumarDodatInfo') {
            //ideme rovno na sumar
            return this.newId;
          }
          console.log('route ' + this.$route.name);
          if (this.$route.name === 'novyPripad') {
            //nove cislo pripadu
            return protectedAxios.get('/pripady/nove-cislo').then(async res => {
              return res.data;
            });
          }

          if (this.$route.name === 'editPripad') {
            //edit pripadu
            if (this.$route.query.duplikovat_predmet) {
              cisloPredmetu = parseInt(this.$route.query.duplikovat_predmet);
            }
            return this.nacitajCache(this.newId, cisloPredmetu).then(_ => {
              cisloPredmetu = _.cisloPredmetu;
              return this.newId;
            });
          }
        })
        .then(async _newId => {
          this.newId = _newId;
          this.cisloObchPripadu = await protectedAxios
            .get(`/pripady/${this.newId}/get-cislo-obch-pripadu`)
            .then(cisloRes => {
              return cisloRes.data;
            });
          localStorage.setItem('curr_new_obc_num', this.newId);
          this.SetPripadAndContinue(cisloPredmetu);
        });
    },
    resetCacheWithPripad() {
      this.setPripad(null);
      return this.resetCache();
    },
    async loadNextForm(currentIndex) {
      if (this.editInitialized) {
        if (this.isStepDisabled(this.currentStep - 1)) this.setStep(this.currentStep);
        return;
      }

      if (
        this.$route.query.kalkulacia == 1 &&
        this.$route.query.cislo_predmetu &&
        currentIndex === 0
      ) {
        this.setStep(5);
        this.editInitialized = true;
        return;
      }

      // if (
      //   this.$route.query.cislo_predmetu &&
      //   this.$route.query.step == null &&
      //   this.$route.query.redirect == null &&
      //   currentIndex === 0
      // ) {
      //   this.setStep(2);
      //   this.editInitialized = true;
      //   return;
      // }

      //ak je aktualny formular nevalidny, tak nenacitavam dalej
      const formValid = this.$refs[currentIndex + 1][0].validateForm();

      if (!formValid) {
        this.setStep(currentIndex + 1);
        this.editInitialized = true;
        return;
      }

      if (
        currentIndex === 4 ||
        (this.$route.query.redirect != null &&
          currentIndex === parseInt(this.$route.query.redirect) - 2) ||
        (parseInt(this.$route.query.redirect) == 1 && currentIndex == 0)
      ) {
        //koncim na kalkulacii
        let nextStep = this.currentStep;
        if (this.$route.query.cislo_predmetu) nextStep = 2;
        if (this.$route.query.duplikovat_predmet) nextStep = 2;
        if (this.$route.query.step) nextStep = parseInt(this.$route.query.step);
        if (this.$route.query.redirect) nextStep = parseInt(this.$route.query.redirect);

        this.setStep(nextStep);

        this.editInitialized = true;
        return;
      }

      this.wizardItems[currentIndex + 1].isAlive = true;
    },
    onPredmetSelect() {
      this.editInitialized = false;
      for (let index = 2; index <= 4; index++) {
        this.wizardItems[index].isAlive = false;
      }
    },
    setNotAliveComponent(componentName = null) {
      let component = null;
      if (componentName == null) {
        component = this.wizardItems.find(c => c.formName == 'PripadyWizardPoistenie');
      } else {
        component = this.wizardItems.find(c => c.formName == componentName);
      }
      component.isAlive = false;
    },
    async checkCacheChanged() {
      return await protectedAxios
        .get('/controls/checkCacheChanged/' + (this.pripad.newId ?? ''))
        .then(res => {
          return res.data == 1 ? true : false;
        });
    },
    resetWizard() {
      this.wizardItems.forEach((form, _) => {
        form.isAlive = false;
        form.dirty = false;
        form.controlsLoaded = false;
      });
      this.currentStep = 0;
      this.closeDialog();
    },
    redirectToNext(savePripad) {
      if (this.saveInProgress) return;
      this.saveInProgress = true;
      this.ulozPripad(savePripad)
        .then(_ => this.resetWizard())
        .then(_ => this.saveDialog.callNext())
        .catch(e => {
          console.error(e);
          this.saveInProgress = false;
          this.closeDialog();
          eventBus.$emit('snack-error', 'Pri odchode z ponuky nastala chyba.');
        });
    },

    async redirectToNewProfile() {
      let idProfile = this.externalUrlData;

      this.resetCacheWithPripad();

      if (idProfile) {
        let url = await store.dispatch('auth/setProfile', idProfile);

        if (url) {
          window.onbeforeunload = null;
          window.location.href = url;
        }
      }
    },

    sumarRedirectToNext() {
      this.resetCacheWithPripad()
        .then(_ => this.resetWizard())
        .then(_ => this.saveDialog.callNext())
        .catch(e => {
          console.error(e);
          this.saveInProgress = false;
          this.closeDialog();
          eventBus.$emit('snack-error', 'Pri odchode z ponuky nastala chyba.');
        });
    },

    async sumarRedirectToLogin() {
      window.onbeforeunload = null;

      await store.dispatch('auth/authenticate', {
        customQueryParams: {
          ref: 'eklient',
          step: this.currentStep,
          obcNum: this.pripad.newId,
        },
      });
    },

    async sumarRedirectToClientZone() {
      await protectedAxios.get('login/client-zone-url').then(res => {
        console.log(res);
        if (res.data?.url) {
          window.onbeforeunload = null;
          window.location.href = res.data.url;
        }
      });
    },

    // confirmCloseAndRedirectToNext() {
    //   this.resetCacheAndWizard();
    // },
    resetAndCloseDialog() {
      this.closeDialog();
      this.saveDialog.callNext = null;
      this.saveDialog.email = null;
    },
    closeSaveDialogWithEmail() {
      this.saveDialogWithEmail = false;
      this.saveEmail = null;
    },
    isStepDisabled(step) {
      let disableEdit = false;
      if(this.currentStep == 6 && step != 5 && !this.pripad.canOpenPredmet){
        disableEdit = true;        
      }
      return disableEdit || (!this.jeNovy && this.wizardItems[step].formName == 'PripadyWizardUvod');
    },
    async kontrolaOdchoduZWizardu(next, to = null) {
      if (
        this.modifikujeOperator ||
        this.nemaPravoEditovat ||
        !this.maStredisko ||
        this.neexistujePripad ||
        (this.isWizardSumar && !this.pripad?.handleExit)
      ) {
        if (this.externalUrlFrom == 'changeProfile') {
          await this.redirectToNewProfile();
          return;
        }
        return this.resetCacheWithPripad().then(next);
      }

      if (this.somethingIsLoading || this.vytvaranieZakaznikaPrebieha) {
        alert('Počas načítavania obchodného prípadu nie je možné opustiť stránku.');
        return;
      }
      let changedCache = await this.checkCacheChanged();
      if (!this.jeDealer && this.externalUrlFrom) {
        return this.klientDialogOdchodu(next);
      } else {
        if (this.pripad?.handleExit || changedCache) {
          if (this.jeDealer) {
            return this.dealerDialogOdchodu(next);
          } else {
            return this.klientDialogOdchodu(next);
          }
        } else {
          if (
            this.$route.name === 'novyPripad' &&
            (to != null ? to.name !== 'pripadSumar' : true)
          ) {
            return this.ulozPripad(false).then(next);
          } else {
            return this.resetCacheWithPripad().then(next);
          }
        }
      }
    },
    dealerDialogOdchodu(next) {
      this.saveDialog.header = '<span class="gs100 f16">Upozornenie</span>';
      this.saveDialog.textClass = [];
      this.saveDialog.text =
        '<span class="f16 white100">Prajete si pred odchodom uložiť rozpracovaný obchodný prípad?</span>';
      this.saveDialog.secondaryBtn = {
        text: 'Nie',
        func: () => this.redirectToNext(false),
        disabled: this.saveInProgress,
      };
      this.saveDialog.primaryBtn = {
        text: 'Áno',
        func: () => this.redirectToNext(true),
        loading: this.saveInProgress,
      };
      this.openDialog(this.saveDialog);
      this.saveDialog.callNext = next;
    },
    async klientDialogOdchodu(next) {
      if (this.externalUrlFrom) {
        if (this.externalUrlFrom == 'changeProfile') {
          if (this.currentStep == 1) {
            await this.redirectToNewProfile();
            return;
          } else {
            this.saveDialog.header = 'Prepnutie do iného profilu';
            this.saveDialog.textClass = ['wizard-close-dialog'];
            this.saveDialog.text =
              'Ste si istý, že chcete ukončiť túto ponuku a začať vytvárať novú ponuku pre iný profil Klientskej zóny?';
            this.saveDialog.closeIcon = {
              value: true,
              func: this.resetAndCloseDialog,
            };
            this.saveDialog.primaryBtn = {
              text: 'Prejsť do iného profilu',
              func: async () => await this.redirectToNewProfile(),
            };
            this.openDialog(this.saveDialog);
            this.saveDialog.callNext = next;
            return;
          }
        }
      }
      if (this.externalUrlFrom !== 'changeProfile') {
        this.saveDialog.header = 'Opustiť Nové financovanie';
        this.saveDialog.textClass = ['wizard-close-dialog'];
        this.saveDialog.text =
          '<span class="upozornenie">Upozornenie:</span> Ak opustíte kalkuláciu Nového finacovania, stratíte všetky údaje, ktoré ste doteraz zadali do kalkulačky.';
        this.saveDialog.closeIcon = {
          value: true,
          func: this.resetAndCloseDialog,
        };
        this.saveDialog.primaryBtn = {
          text: 'Opustiť',
          func: () => this.redirectToNext(false),
        };
        this.openDialog(this.saveDialog);
        this.saveDialog.callNext = next;
      }
    },
    redirectToExternalUrl(externalUrl) {
      this.kontrolaOdchoduZWizardu(_ => {
        this.externalRedirect = true;
        window.location.href = externalUrl;
      }, this.$router.currentRoute);
    },
    beforeUnloadHandler(event) {
      if (this.externalRedirect) return;
      event.preventDefault();
      event.returnValue = 'Skutočne si prajete odísť zo stránky?';
    },
    updateStepperPadding() {
      this.$refs.wizardStepperItems.style.paddingBottom = `${this.$refs.wizardFooter.offsetHeight}px`;
    },
  },
  async mounted() {
    this.isWizardSumar = true;
    this.editInitialized = this.$route.name === 'novyPripad';
    this.newId = this.$route.params.new_id;

    this.jeNovy = true;
    if (this.newId) {
      protectedAxios
        .get(`/pripady/${this.newId}/get-cislo-obch-pripadu`)
        .then(async cisloRes => {
          if (cisloRes.data) {
            this.cisloObchPripadu = cisloRes.data;
            protectedAxios.get(`/pripady/${this.newId}/je-novy`)
            .then(async novyRes => {
              this.jeNovy = novyRes.data == 1 ? true : false;
              protectedAxios
                .get(`/pripady/${this.newId}/modify-info`)
                .then(res => {
                  this.modifikujeOperator = res.data.modifikujeOperator;
                  this.editInitialized =
                    this.$route.query.redirect == null &&
                    res.data.modifikovalOperator?.toLowerCase() !== this.user.login?.toLowerCase();
                  if (this.modifikujeOperator) {
                    window.onbeforeunload = null;
                    this.editInitialized = true;
                    return Promise.reject();
                  }
                })
                .then(_ => protectedAxios.get(`/pripady/${this.newId}/moze-editovat`))
                .then(res => {
                  if (!res.data) {
                    window.onbeforeunload = null;
                    this.nemaPravoEditovat = true;
                    this.editInitialized = true;
                    return Promise.reject();
                  }
                })
                .then(
                  _ => {
                    let redirectToEdit = false;
                    let continueEdit = false;
                    protectedAxios
                      .get(`pripady/${this.newId}/kontrola-refi`)
                      .then(res => {
                        if (res.data) {
                          let data = res.data;
                          if (data.cislo_plz_string.length == 0) {
                            if (data.error_text.length == 0) {
                              return Promise.resolve();
                            } else {
                              eventBus.$emit('snack-error', data.error_text);
                              this.$router.push('/');
                            }
                          } else {
                            if (data.error_text.length > 0) {
                              if (data.prepocet) {
                                this.loadingRefi.loading = true;
                                this.loadingRefi.text = data.error_text;
                                return protectedAxios
                                  .post(
                                    `kalk/prepocet-refi`,
                                    {
                                      cisloPlz: data.cislo_plz_string,
                                      // cisloPlz: '159000387943,159000380943,159000385943,159000386943',
                                      newId: this.newId,
                                      // cisloObchPripadu: this.cisloObchPripadu,
                                    },
                                    {
                                      headers: {
                                        'Content-Type': 'application/json',
                                      },
                                    }
                                  )
                                  .then(async res => {
                                    this.loadingRefi.loading = false;
                                    this.loadingRefi.text = '';
                                    if (res.data) {
                                      if (res.data?.errors) {
                                        let errors = res.data.errors;
                                        for (let index in errors) {
                                          eventBus.$emit('snack-error', errors[index].error_text);
                                        }
                                      }
                                      if (res.data?.cisloPlz) {
                                        await this.schvalovaniePoPrekalkulovani([
                                          res.data?.cisloPlz,
                                        ]);
                                      }
                                    } else {
                                      await this.schvalovaniePoPrekalkulovani([
                                        data.cislo_plz_string,
                                      ]);
                                    }
                                  })
                                  .catch(e => {
                                    console.error(e);
                                    if (e?.response?.data?.errors?.length > 0) {
                                      let errors = e.response.data.errors;
                                      for (let index in errors) {
                                        if (
                                          errors[index].error_code == 663 &&
                                          (this.$route.name === 'pripadSumar' ||
                                            this.$route.name === 'pripadSumarNajomca')
                                        ) {
                                          redirectToEdit = true;
                                        }
                                        if (
                                          errors[index].error_code == 663 &&
                                          this.$route.name === 'editPripad'
                                        ) {
                                          continueEdit = true;
                                        }
                                        eventBus.$emit('snack-error', errors[index].error_text);
                                      }
                                      if (continueEdit) {
                                        this.loadingRefi.loading = false;
                                        this.loadingRefi.text = '';
                                        return Promise.resolve();
                                      }
                                    } else {
                                      eventBus.$emit('snack-error', 'Chyba pri prekalkulovani');
                                    }
                                    return Promise.reject();
                                  });
                              } else {
                                eventBus.$emit('snack-error', data.error_text);
                                return Promise.resolve();
                              }
                            }
                          }
                        }
                        return Promise.reject();
                      })
                      .then(() => {
                        this.loadPripad(this.newId);
                      })
                      .catch((e) => {
                        if (e?.response?.status == 403) {
                          return Promise.reject(e);
                        }
                        if (redirectToEdit) {
                          this.$router.push(`/obchodny-pripad/${this.newId}`);
                        } else {
                          // TODO presmerovat kam ?
                          window.location = "https://tatraleasing.sk"
                        }
                      });
                  },
                  _ => {}
                );
            })
            .catch(e => {
              return Promise.reject(e);
            });
          } else {
            window.onbeforeunload = null;
            eventBus.$emit('snack-error', 'Obchodný prípad neexistuje!');
            this.neexistujePripad = true;
            this.$router.push('/');
          }
        })
        .catch(e => {
          console.log(e);
          console.log(e?.response?.status);
          if (e?.response?.status) {
            this.nemaPravoEditovat = true;
            this.editInitialized = true;
          }
        });
    } else {
      this.maStredisko = await protectedAxios.get(`/login/ma-stredisko`).then(res => res.data);

      if (this.maStredisko) this.loadPripad(null);
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (isSumarRouteNormalization(to, from)) {
      next();
      return;
    }

    this.kontrolaOdchoduZWizardu(next, to);
  },
  created() {
    window.onbeforeunload = this.beforeUnloadHandler;
  },
  beforeDestroy() {
    localStorage.removeItem('curr_new_obc_step');
    localStorage.removeItem('curr_new_obc_num');
    localStorage.removeItem('curr_anonymous_liw_filip');
    window.onbeforeunload = null;
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>
<style lang="sass">
@import "../styles/vuetify-material/global/_colors.sass"
</style>
